export default __webpack_public_path__ + "static/media/Image-3.ea2b8598.png";